import { LanguageCode } from '../types';

export const getLanguageCode = (language: string): LanguageCode => {
  if (language.startsWith('en')) {
    return LanguageCode.EN;
  } else {
    return LanguageCode.DE;
  }
};
